import { toRem } from '../../tools';

const parts = ['control', 'label', 'description', 'icon'];

function baseStyleControl(props) {
  const { colorScheme: c } = props;

  return {
    width: '100%',
    transition: 'all 200ms ease 0s;',
    border: '2px solid',
    borderRadius: 'sm',
    borderColor: 'inherit',
    color: 'white',

    _checked: {
      bg: `${c}.500`,
      borderColor: `${c}.500`,
      color: 'white',

      _hover: {
        bg: `${c}.600`,
        borderColor: `${c}.600`,
      },

      _disabled: {
        borderColor: 'gray.200',
        bg: 'gray.200',
        color: 'gray.500',
      },
    },

    _indeterminate: {
      bg: `${c}.500`,
      borderColor: `${c}.500`,
      color: 'white',
    },

    _disabled: {
      bg: 'gray.100',
      borderColor: 'gray.100',
    },

    _focus: {
      boxShadow: 'outline',
    },

    _invalid: {
      borderColor: 'red.500',
    },
  };
}

const baseStyleLabel = {
  userSelect: 'none',
  _disabled: { opacity: 0.4 },
};

const baseStyleIcon = {
  fontSize: '0.625rem',
};

const baseStyle = (props) => ({
  control: baseStyleControl(props),
  label: baseStyleLabel,
  icon: baseStyleIcon,
});

const sizes = {
  sm: {
    control: { height: toRem(12), width: toRem(12) },
    label: { fontSize: 'xs' },
  },
  md: {
    control: { width: 3, height: 3 },
    label: { fontSize: 'sm' },
  },
  lg: {
    control: { width: toRem(20), height: toRem(20) },
    label: { fontSize: 'md' },
  },
};

const defaultProps = {
  size: 'md',
  colorScheme: 'blue',
};

export default {
  parts,
  baseStyle,
  sizes,
  defaultProps,
};
